<aaa-modal
  i18n-title
  i18n-subtitle
  [isOpen]="isOpen"
  [customClass]="customClass"
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  contentMode="fit"
  title="How many people need a ride in the tow truck?"
  subtitle="Safety is our top priority. Our service vehicles can only accommodate up to 2 riders."
  (aaaModalWillDismiss)="handleDismiss()"
>
  <div class="modal-container">
    <aaa-button
      *ngFor="let option of passengerOptions; let i = index"
      aria-label="select option"
      i18n-arial-label
      expand="block"
      variant="outline"
      type="button"
      [tabIndex]="500 + i"
      (click)="selectOption(option)"
    >
      <span class="ion-text-capitalize">{{ option.label }}</span>
    </aaa-button>
  </div>
</aaa-modal>
